export default {
  create: {
    success: "Création de l'auteur effectué avec succès",
    error: "Impossible de créer l'auteur"
  },
  update: {
    success: "Modification de l'auteur effectué avec succès",
    error: "Impossible de modifier l'auteur"
  },
  delete: {
    success: "Suppression de l'auteur effectué avec succès",
    error: "Impossible de supprimer l'auteur"
  }
}
